import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  TextField,
  Checkbox,
  FormControl,
  InputAdornment,
  Icon,
  ListItem,
  ListItemText,
  ListItemIcon,
  List,
  Tooltip,
  Button,
  InputLabel,
  Select,
  MenuItem,
  ButtonGroup,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { connect } from 'react-redux';
import propTypes from '../../../../utils/propTypes';
import {
  TODAY_TYPE,
  THIS_WEEK_TYPE,
  THIS_MONTH_TYPE,
} from '../../../../utils/dashboardHelper';
import Property from '../../../widgets/Property';
import styles from './styles';

export class FilterEventComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState = () => {
    const {
      overrideSearchEvents,
      searchEvents: searchEventsProp,
    } = this.props;
    const searchEvents = overrideSearchEvents || searchEventsProp;

    return { searchEvents };
  }

  componentDidUpdate(prevProps) {
    const { overrideSearchEvents } = this.props;
    if (prevProps.overrideSearchEvents
      && JSON.stringify(prevProps.overrideSearchEvents)
      !== JSON.stringify(overrideSearchEvents)) {
      this.setState(this.getInitialState());
    }
  }

  handleKeyPress = (event) => {
    const { onEnter } = this.props;
    if (event.keyCode === 13) {
      event.preventDefault();
      onEnter();
    }
  }

  handleSearchTextChange = (event) => {
    const { updateSearchEventsState } = this.props;
    const { target: { value: searchText } } = event;
    this.setState((prevState) => ({
      searchEvents: {
        ...prevState.searchEvents,
        searchText,
      },
    }), () => {
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.searchText, 'searchText');
    });
  }

  handleToggleArchived = (event) => {
    const { target: { checked: includeArchived } } = event;
    this.setState((prevState) => ({
      searchEvents: {
        ...prevState.searchEvents,
        includeArchived,
      },
    }), () => {
      const { updateSearchEventsState } = this.props;
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.includeArchived, 'includeArchived');
    });
  }

  handleToggleComplete = (event) => {
    const { target: { checked: includeComplete } } = event;
    this.setState((prevState) => ({
      searchEvents: {
        ...prevState.searchEvents,
        includeComplete,
      },
    }), () => {
      const { updateSearchEventsState } = this.props;
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.includeComplete, 'includeComplete');
    });
  }

  handleChangeCompletedLookBackTimeMillis = (event) => {
    this.setState((prevState) => ({
      searchEvents: {
        ...prevState.searchEvents,
        completedLookBackTimeMillis: event.target.value,
      },
    }), () => {
      const { updateSearchEventsState } = this.props;
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.completedLookBackTimeMillis, 'completedLookBackTimeMillis');
    });
  }

  handleStartDateChange = (e) => {
    const { _d: newDateValue } = e;
    this.setState((prevState) => ({
      searchEvents: {
        ...prevState.searchEvents,
        startDate: newDateValue
          ? new Date(newDateValue)
          : null,
      },
    }), () => {
      const { updateSearchEventsState } = this.props;
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.startDate, 'startDate');
    });
  }

  handleEndDateChange = (e) => {
    const { _d: newDateValue } = e;
    this.setState((prevState) => ({
      searchEvents: {
        ...prevState.searchEvents,
        endDate: newDateValue
          ? new Date(newDateValue)
          : null,
      },
    }), () => {
      const { updateSearchEventsState } = this.props;
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.endDate, 'endDate');
    });
  }

  selectDateRange = (selectedDateType) => {
    this.setState((prevState) => {
      const newSearchEvents = prevState.searchEvents;
      newSearchEvents.startDate = null;
      newSearchEvents.endDate = null;

      if (selectedDateType === TODAY_TYPE) {
        newSearchEvents.presetDateFilter = TODAY_TYPE;
      } else if (selectedDateType === THIS_WEEK_TYPE) {
        newSearchEvents.presetDateFilter = THIS_WEEK_TYPE;
      } else if (selectedDateType === THIS_MONTH_TYPE) {
        newSearchEvents.presetDateFilter = THIS_MONTH_TYPE;
      } else {
        newSearchEvents.presetDateFilter = null;
      }
      return { searchEvents: newSearchEvents };
    }, () => {
      const { updateSearchEventsState } = this.props;
      const { searchEvents } = this.state;
      updateSearchEventsState(searchEvents.endDate, 'endDate');
      updateSearchEventsState(searchEvents.presetDateFilter, 'presetDateFilter');
      updateSearchEventsState(searchEvents.startDate, 'startDate');
    });
  }

  render() {
    const {
      classes,
      selectedView: propsSelectedView,
      overrideSelectedView,
    } = this.props;
    const selectedView = overrideSelectedView || propsSelectedView;
    const { searchEvents } = this.state;
    const analyticsMode = selectedView.key === 'analytics';

    return (
      <div>
        <div className={classes.section}>
          <Property label="Search" disableGutters>
            <Tooltip title="Search based on event name, comments, and custom fields" className={classes.flex}>
              <TextField
                id="searchText"
                variant="outlined"
                type="search"
                autoFocus
                className={classes.textField}
                value={searchEvents.searchText || ''}
                onChange={this.handleSearchTextChange}
                autoComplete="new-password"
                onKeyDown={this.handleKeyPress}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon>
                        search
                      </Icon>
                    </InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
                classes={{ root: classes.input }}
              />
            </Tooltip>
          </Property>

          <div className={classes.section}>
            <List className={classes.list}>
              <ListItem
                disableGutters
                className={classes.listItem}
              >
                <ListItemIcon>
                  <Checkbox
                    checked={analyticsMode || searchEvents.includeComplete}
                    onChange={this.handleToggleComplete}
                    disabled={analyticsMode}
                    value="includeComplete"
                    color="primary"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={(
                    <h6
                      style={{
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      Include completed events
                    </h6>
                  )}
                  classes={{ primary: classes.toggleText }}
                />
              </ListItem>
              {
                    (analyticsMode || searchEvents.includeComplete)
                      && (
                        <FormControl variant="outlined" className={classes.selectFormControl} margin="dense">
                          <InputLabel id="completed-events-filter">
                            Include completed events for
                          </InputLabel>
                          <Select
                            labelId="completed-events-filter"
                            id="completed-events-filter"
                            value={searchEvents.completedLookBackTimeMillis || 0}
                            onChange={this.handleChangeCompletedLookBackTimeMillis}
                            labelWidth={235}
                            inputProps={{ margin: 'none' }}
                          >
                            <MenuItem value={0}>All time</MenuItem>
                            <MenuItem value={900000}>Last 15 minutes</MenuItem>
                            <MenuItem value={1800000}>Last 30 minutes</MenuItem>
                            <MenuItem value={3600000}>Last 1 hour</MenuItem>
                            <MenuItem value={28800000}>Last 8 hours</MenuItem>
                            <MenuItem value={86400000}>Last 1 day</MenuItem>
                            <MenuItem value={604800000}>Last 7 days</MenuItem>
                            <MenuItem value={2592000000}>Last 30 days</MenuItem>
                          </Select>
                        </FormControl>
                      )
                  }
              <ListItem disableGutters className={classes.listItem}>
                <ListItemIcon>
                  <Checkbox
                    checked={searchEvents.includeArchived}
                    onChange={this.handleToggleArchived}
                    value="includeArchived"
                    color="primary"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={(
                    <h6
                      style={{
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      Include archived events
                    </h6>
                  )}
                  classes={{ primary: classes.toggleText }}
                />
              </ListItem>
            </List>
          </div>
          <div className={classes.section}>
            <div className={classes.sectionHeaderContainer}>
              <h6 className={classes.sectionHeaderText}>
                Include events created...
              </h6>
              <Tooltip title="Search for events started in date range">
                <Icon className={classes.info} color="disabled">
                  info
                </Icon>
              </Tooltip>
            </div>
            <ButtonGroup className={classes.buttonGroup}>
              <Button
                variant={searchEvents.presetDateFilter === TODAY_TYPE
                  ? 'contained'
                  : 'outlined'}
                size="small"
                className={classes.dateButton}
                color="primary"
                onClick={() => this.selectDateRange(TODAY_TYPE)}
              >
                Today
              </Button>
              <Button
                variant={searchEvents.presetDateFilter === THIS_WEEK_TYPE
                  ? 'contained'
                  : 'outlined'}
                size="small"
                className={classes.dateButton}
                color="primary"
                onClick={() => this.selectDateRange(THIS_WEEK_TYPE)}
              >
                This Week
              </Button>
              <Button
                variant={
                      searchEvents.presetDateFilter === THIS_MONTH_TYPE
                      || (!searchEvents.startDate && analyticsMode)
                        ? 'contained'
                        : 'outlined'
                    }
                size="small"
                className={classes.dateButton}
                color="primary"
                onClick={() => this.selectDateRange(THIS_MONTH_TYPE)}
              >
                This Month
              </Button>
              <Button
                variant={searchEvents.presetDateFilter === null
                  ? 'contained'
                  : 'outlined'}
                size="small"
                className={classes.dateButton}
                color="primary"
                onClick={() => this.selectDateRange(null)}
              >
                Custom
              </Button>
            </ButtonGroup>
            {
                  searchEvents.presetDateFilter === null
                    && (
                      <div>
                        <FormControl fullWidth>
                          <KeyboardDatePicker
                            value={searchEvents.startDate}
                            onChange={this.handleStartDateChange}
                            inputProps={{ placeholder: 'Start' }}
                            InputLabelProps={{ shrink: true }}
                            disableToolbar
                            variant="inline"
                            disableFuture
                            autoOk
                            format="MM/DD/YYYY"
                            margin="dense"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <KeyboardDatePicker
                            value={searchEvents.endDate}
                            onChange={this.handleEndDateChange}
                            inputProps={{ placeholder: 'End (optional)' }}
                            InputLabelProps={{ shrink: true }}
                            disableToolbar
                            variant="inline"
                            disableFuture
                            autoOk
                            format="MM/DD/YYYY"
                            margin="dense"
                          />
                        </FormControl>
                        <small>Leave fields blank to search all events</small>
                      </div>
                    )
                }
          </div>
        </div>
      </div>
    );
  }
}

FilterEventComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  searchEvents: PropTypes.shape(propTypes.searchEvents).isRequired,
  updateSearchEventsState: PropTypes.func,
  onEnter: PropTypes.func,
  selectedView: PropTypes.object,
  overrideSearchEvents: PropTypes.object,
  overrideSelectedView: PropTypes.object,
};

FilterEventComponent.defaultProps = {
  onEnter: () => {},
  selectedView: { key: 'list' },
  overrideSearchEvents: null,
  overrideSelectedView: null,
  updateSearchEventsState: () => {},
};

export const mapStateToProps = (state) => ({
  searchEvents: { ...state.dashboard.currentFilterDashboard.dashboardData },
  selectedView: state.dashboard.selectedView,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(styles, { withTheme: true })(FilterEventComponent));
